/**
 * @file 产品二级页
 * @author wangzhuang
 * */

import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import ProBanner from '../../components/ProBanner';
import ProductTitle from '../../components/ProductTitle';

class Product extends Component {
    static propTypes = {
        bannerInfo: PropTypes.object
    };

    constructor(props, context) {
        super(props, context);
        this.state = {};
    }

    componentWillMount() {
        if (this.isPC()) {
            location.href = '/newsite/security_privacy';
        }
    }

    componentDidMount() {
    }

    render() {
        const bannerInfo = this.props.bannerInfo || {};

        return (
            <div className={'product'}>
                <div className="pro-banner-box bg-new">
                    <ProBanner
                        title={bannerInfo.title}
                        urlText={bannerInfo.urlText}
                        bgImg={bannerInfo.bgImg}
                        url={bannerInfo.url}
                    />
                    {bannerInfo.nextText ? (
                        <a href={bannerInfo.nextUrl} target="_blank" className="compliance-btn">
                            {bannerInfo.nextText}
                        </a>
                    ) : null}
                </div>

                <div className={'product-des'}>
                    {
                        '依托百度领先的数据安全能力及隐私保护技术，数据安全与隐私解决方案集成数据治理与敏捷大数据'
                        + '分析、AI数据脱敏及联邦计算，覆盖数据资产管理、敏感数据处理及安全合规数据流通三大场景，助力企业实现数据全生命周'
                        + '期的安全治理及防护。'
                    }
                </div>

                <div className={'product-mod'}>
                    <ProductTitle title={'业务结构'}/>
                </div>

                <div className={'product-mod pr sp-step'}>
                    <div className={'structure'}/>
                    <a href={'//anquan.baidu.com/m/product/11'} className={'shadow1'}/>
                    <a href={'//anquan.baidu.com/m/product/36'} className={'shadow2'}/>
                    <a href={'//anquan.baidu.com/m/product/63'} className={'shadow3'}/>
                    <a href={'//anquan.baidu.com/m/product/10'} className={'shadow4'}/>
                </div>

                <div className={'product-mod'}>
                    <ProductTitle title={'方案优势'}/>
                </div>

                <div className={'product-mod sec-p-box'}>
                    <div className={'proinfo-box mui-flex'}>
                        <div className={'proinfo-box-icon'}>
                            <img
                                src={require('../../asset/image/product/sp_lingxian.svg')}
                                width={'100%'}
                            />
                        </div>
                        <div className={'cell'}>
                            <div className={'proinfo-box-title'}>领先前沿的数据安全技术</div>
                            <div className={'proinfo-box-des'}>
                                {'依托百度安全在数据安全及隐私保护方向领先的安全技术(MPC、TEE、DP)、AI技术(图像识别、'
                                + '自然语言处理)长期积累，保障整体数据安全可控'}
                            </div>
                        </div>
                    </div>

                    <div className={'proinfo-box mui-flex'}>
                        <div className={'proinfo-box-icon'}>
                            <img
                                src={require('../../asset/image/product/sp_wending.svg')}
                                width={'100%'}
                            />
                        </div>
                        <div className={'cell'}>
                            <div className={'proinfo-box-title'}>稳定高效的工程能力</div>
                            <div className={'proinfo-box-des'}>
                                {'支持集群分布式、并发计算、算法优化等功能，实现海量大数据安全生产流通，保障数据链路稳定高效'}
                            </div>
                        </div>
                    </div>

                    <div className={'proinfo-box mui-flex'}>
                        <div className={'proinfo-box-icon'}>
                            <img
                                src={require('../../asset/image/product/sp_duli.svg')}
                                width={'100%'}
                            />
                        </div>
                        <div className={'cell'}>
                            <div className={'proinfo-box-title'}>独立私有化部署方式</div>
                            <div className={'proinfo-box-des'}>
                                {'支持私有化+SaaS的部署方式，还可根据用户业务需求场景独立私有化部署，能够与区块链、边缘计算等业务进行有机融合'}
                            </div>
                        </div>
                    </div>
                </div>

                <div className={'product-mod'}>
                    <ProductTitle title={'方案特点'}/>
                </div>

                <div className={'product-mod'}>
                    <div className={'profun-box mui-flex'}>
                        <div className={'profun-box-icon'}>
                            <div className={'star'}>
                            </div>
                        </div>
                        <div className={'cell'}>
                            <div className={'profun-box-title'}>安全领先的联邦计算系统</div>
                            <div className={'profun-box-des'}>
                                {'基于百度安全先进的MPC、TEE、DP安全技术，满足政务数据的安全共享，金融数据的联合风控、'
                                + '医疗数据的联合建模以及广告领域的联合营销等复杂业务场景'}
                            </div>
                        </div>
                    </div>

                    <div className={'profun-box mui-flex'}>
                        <div className={'profun-box-icon'}>
                            <div className={'star'}>
                            </div>
                        </div>
                        <div className={'cell'}>
                            <div className={'profun-box-title'}>安全高效的数据治理调度系统</div>
                            <div className={'profun-box-des'}>
                                {'支持批量任务的开发与调度管理，实现异常任务监控探查，在保证数据高效使用及价值挖掘的基础上，支持完善的资产权限控制'}
                            </div>
                        </div>
                    </div>

                    <div className={'profun-box mui-flex'}>
                        <div className={'profun-box-icon'}>
                            <div className={'star'}>
                            </div>
                        </div>
                        <div className={'cell'}>
                            <div className={'profun-box-title'}>灵活易用的数据资产管理与价值挖掘系统</div>
                            <div className={'profun-box-des'}>
                                {'支持快速搭建数据门户，实现自助多维数据敏捷分析，自动生成阶段性报告，专业的数据可视化呈现，满足用户的数据分析挖掘场景需求'}
                            </div>
                        </div>
                    </div>

                    <div className={'profun-box mui-flex'}>
                        <div className={'profun-box-icon'}>
                            <div className={'star'}>
                            </div>
                        </div>
                        <div className={'cell'}>
                            <div className={'profun-box-title'}>健全合规的敏感数据保护系统</div>
                            <div className={'profun-box-des'}>
                                {'基于百度先进的AI技术体系，支持医疗领域影像及电子病历的脱敏保护，满足GDPR等规范要求的敏感数据类'
                                + '行保护，严格遵守国标、行标的产品技术要求，提供有效的合规性背书'}
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

function mapStateToProps(state) {
    return {};
}

function mapDispatchToProps(dispatch) {
    return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(Product);



// WEBPACK FOOTER //
// ./src/containers/product/securityPrivacy.js